<template>
  <div class="footer">
    <p class="footermenu">
     <span @click="routerTo(null)" >首页</span>
      <span v-for="(item,index) in menuList" :key="index"  @click="routerTo(item)">
        {{item.column_name}}
      </span>
    </p>
  </div>
</template>

<script>
  import menuApi from "../api/menuApi";

  export default {
    name: 'Footer',
    data() {
      return {
        menuList: []
      }
    },
    created() {

      this.loadMenu();
    },
    methods:{
      loadMenu(){
        menuApi.getMenu().then(res => {
          if (res.data.code === 200) {
            this.menuList=res.data.data;
          }
        })
      },
      routerTo(val){
        if(val==null){
          this.$router.push({
            name: 'Index',
            params: {
              id:null
            }
          })
        }else{
          let id=null;
          if(val.childrens && val.childrens.length>0){
            id=val.childrens[0].id;
          }else{
            id=val.id
          }

          this.$router.push({
            name: 'ListPage',
            query:{t:id},
            params: {
              id:id
            }
          })
        }

      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .footer{
    height: 174px;
    background: #2980C8;
    line-height: 174px;

  }
  .footermenu{
    text-align: center
  }
  .footermenu span{
    margin-right: 20px;
    color: #FFFFFF;;
    cursor: pointer;
  }
  .footermenu span:last-child{
    margin-right: 0;
  }
</style>
